<div [ngClass]="[backgroundTheme, textTheme]" [ngStyle]="backgroundImageCss">
  <section
    sc-placeholder
    name="page-row-container"
    [rendering]="rendering"
    [ngClass]="containerClass$ | async"
    wlAutomationId="main-content"
  ></section>
</div>
